import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-arrow",
  viewBox: "0 0 15 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"rotate(-90 7.5 7)\"><g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.143\" clip-path=\"url(#a)\"><path d=\"M7.357 1.285v12M2.786 8.143l4.571 5.142M12.5 8.143 10.214 11\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M14.214.143v13.714H.5V.143z\"></path></clipPath></defs></g>", 1)
  ]))]))
}
export default { render: render }